import React from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';

import Main from './main';
import PublicationIndex from '../publications/publicationIndex';
import UpcomingPublicationIndex from '../upcomingPublications/upcomingPublicationIndex';
import ReportsIndex from '../Reports/ReportsIndex';

const Routes = () => (
    <Router>
        <Main>
            <Route exact path="/" component={PublicationIndex}/>
            <Route exact path="/upcoming-publications" component={UpcomingPublicationIndex} />
            <Route exact path="/reports" component={ReportsIndex} />
        </Main>
    </Router>
);

export default Routes;
